import React from 'react';
import PropTypes from 'prop-types';

// import style from './index.module.scss';

function ReadAnswers({ topicName, questionList }) {  
  return (
    <>
      {questionList.map(question => (
        <div key={question.id}>
          {JSON.stringify(question)}
        </div>
      ))}
    </>
  );
}

ReadAnswers.propTypes = {
  topicName: PropTypes.string.isRequired,
  questionList: PropTypes.array.isRequired,
};

export default ReadAnswers;
